import { Component, Mixins } from "vue-property-decorator";
import EntryMixin from "@/mixins/http/Entry";
import store from "@/store";

@Component
class EntryService extends Mixins(EntryMixin) {
  created() {
    this.$store = store;
  }
}

export default new EntryService();
